import moment from "moment";

class DateUtil {
    static formatDate(timestamp, pattern) {
        if (!timestamp && timestamp !== 0) {
            return "-";
        }
        const date = new Date(timestamp);
        return moment(date).format(pattern);
    }

    static formatDateFromTimestamp(timestamp) {
        if (!timestamp && timestamp !== 0) {
            return "-";
        }
        const date = new Date(timestamp);
        return moment(date).format("yyyy-MM-DD");
    }

    static formatDateCommitTimestamp(timestamp) {
        if (!timestamp) {
            return "-";
        }
        const date = new Date(timestamp);
        return moment(date).format("yyyy-MM-DD HH:mm");
    }

    static formatMonthDateCommitTimestamp(timestamp) {
        if (!timestamp) {
            return "-";
        }
        // 转化成年月格式
        const date = new Date(timestamp);
        return moment(date).format("yyyy-MM");
    }

    static calculateAgeFromTimestamp(timestamp) {
        if (!timestamp) {
            return "-";
        }
        const birthdate = moment(timestamp);
        const today = moment();
        return today.diff(birthdate, "years");
    }

    // 按time是秒计算
    static formatDuration(time) {
        let obj = {
            minutes: null,
            seconds: null,
        };
        let minutes = Math.floor(time / 60);
        let seconds = Math.floor(time - minutes * 60);
        obj.minutes = String(minutes).padStart(2, "0");
        obj.seconds = String(seconds).padStart(2, "0");
        return obj;
    }

    // 按时间戳是毫秒计算小时
    static formatHoursDuration(timeInMilliseconds) {
        let obj = {
            hours: null,
            minutes: null,
        };
        let seconds = Math.floor(timeInMilliseconds / 1000); // 将毫秒转换为秒
        let minutes = Math.floor(seconds / 60); // 计算分钟数
        obj.hours = String(Math.floor(minutes / 60)).padStart(2, "0"); // 计算小时数，并格式化为两位数
        obj.minutes = String(minutes % 60).padStart(2, "0"); // 计算剩余的分钟数，并格式化为两位数
        return obj;
    }

    static formatCostAvg(time) {
        if (!time) {
            return "-";
        }
        return Math.round(time / 1000);
    }
}

export default DateUtil;
